export const sweetBeanDonutHoles = {
  id: "sweetBeanDonutHoles",
  link: "/#/recipes/recipes/sweetBeanDonutHoles",
  name: "Sweet Bean Donut Holes",
  cuisine: "Alethi",
  summary:
    "Crispy on the outside, chewy on the inside, and with sweet bean paste at the center.",
  inspiration: "Mochi Donuts",
  quantity: "20",
  time: "30 minutes",
  notes:
    "Pastries are mentioned in the books, but we don't get many details. So I took what I had available to me and tried to figure out what pastries would naturally follow. We know the Alethi have flatbread filled with sweet bean paste (Words of Radiance ch 59), and deep frying is a known cooking method, so these donuts holes seemed a good guess.",
  quotes:
    "Tables lined the walkway here, piled with food. Candied meats, stacks of flatbread crusted with sugar, fruits and pastries. (Oathbringer, ch 78)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/donut-holes-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "glutinousRiceFlour",
          display: "1 cup glutinous rice flour"
        },
        {
          item: "powderedSugar",
          display: "1/4 cup powdered sugar"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "dairy",
          display: "1 tbsp butter"
        },
        {
          item: "water",
          display: "1/4 cup water, plus additional"
        },
        {
          item: "vegetableOil",
          display: "Vegetable oil for frying"
        },
        {
          item: "beanPaste",
          display: "1/4 cup sweet bean paste"
        },
        {
          item: "cinnamon",
          display: "2 tsp cinnamon"
        },
        {
          item: "sugar",
          display: "1/4 cup granulated sugar"
        }
      ]
    }
  ],
  steps: [
    "In a bowl, mix the glutinous rice flour, powdered sugar, and salt. Cut or crumble in the butter until the mixture resembles coarse crumbs.",
    "Add 1/4 cup water and mix well. Add additional water, 1 tsp at a time, to get to a dough that you can knead without it cracking. Knead well.",
    "Pinch off sections and roll into 1 inch balls. Fry at 375 degrees Fahrenheit, stirring or shaking occasionally to help them cook on all sides, until lightly golden and crispy on the outside, about 10 minutes.",
    "To fill the donut holes, I use a plastic syringe - the type used for giving medicine to babies. Fill the syringe with bean paste.",
    "Once the donut holes are cooked, remove from the oil and let drain. Let cool just long enough to handle. Fill each one with 1/2 tsp bean paste.",
    "Mix the cinnamon and sugar in a bowl, then roll the filled donut holes in the cinnamon sugar. May be served warm or room temperature."
  ]
}
